export class TypeUtils {
  // static ExampleTypeEnum: typeof ExampleTypeEnum = ExampleTypeEnum;
}
